import { useRouter } from 'next/router';
import { PlusOutlined } from '@ant-design/icons';
import If from 'global/Common/If';
import ComposeSvg from 'global/Icons/ComposeSvg';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import {
  ButtonDiscover,
  ContentWrapper,
  EmptyStateWrapper,
  Img,
  ButtonCompose,
} from './styled';

interface EmptyStateProps {
  description?: string;
  onDiscover?: () => void;
  isCurrentUser?: boolean;
}

function EmptyState({
  description = 'Add your favourite investors and monitor your stocks',
  onDiscover,
  isCurrentUser,
}: EmptyStateProps) {
  const router = useRouter();

  if (isCurrentUser !== undefined) {
    return (
      <EmptyStateWrapper>
        <Img
          src="/icon/compose-empty.svg"
          alt="Empty stream"
          style={{ marginBottom: '16px' }}
        />
        <ContentWrapper>
          {/* @ts-expect-error */}
          <Text size="13px" color="#969696" mb="20px">
            Belum ada postingan
          </Text>
          <If condition={isCurrentUser}>
            <ButtonCompose
              onClick={() =>
                router.push({
                  pathname: '/stream',
                  query: { compose: '1' },
                })
              }
            >
              <ComposeSvg />
              Tulis Postingan
            </ButtonCompose>
          </If>
        </ContentWrapper>
      </EmptyStateWrapper>
    );
  }

  return (
    <EmptyStateWrapper>
      <Img src="/images/empty_stream_box.png" alt="Empty stream" />
      <ContentWrapper>
        {/* @ts-expect-error */}
        <Text family="bold" size="18px" mb="10px">
          Your Stream is Empty
        </Text>
        {/* @ts-expect-error */}
        <Text size="16px" color={color.highgray} weight="bold" mb="32px">
          {description}
        </Text>
        {onDiscover ? (
          <ButtonDiscover onClick={onDiscover}>
            <PlusOutlined style={{ marginRight: '8px' }} />
            Discover
          </ButtonDiscover>
        ) : null}
      </ContentWrapper>
    </EmptyStateWrapper>
  );
}

export default EmptyState;
